import React, { PureComponent } from "react";
import SimpleBottomNavigation from "./components/SimpleBottomNav";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import VerticalSpace from "./components/VerticalSpace";
import AppConfig from "../../config/appconfig.json";
import { Route } from "react-router-dom";
import Button from "@material-ui/core/Button";
import KBELogo from "../account/img/kbe-Logo-66454.png";

export default class Invoices extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      invoices: []
    };
    // this.handleInvPayment = this.handleInvPayment.bind(this);
  }

  // handleInvPayment(inv) {
  //   console.log(inv);
  //   if (inv.PaymentDue !== "") {

  //   }
  //   // window.location.href = "/inv_payment";
  // }

  componentDidMount() {
    const kbeSid = localStorage.getItem("kbeSid");
    let isCheckInvoiceFailed = false;
    // Call Back-End Services
    fetch(`${AppConfig.BACK_END_URL}/APIClient/CheckInvoice?client=` + kbeSid)
      .then(response => {
        // console.log(response);
        if (response.ok === false) {
          isCheckInvoiceFailed = true;
        }
        return response.json();
      })
      .then(json => {
        if (isCheckInvoiceFailed) {
          const invoiceList = localStorage.getItem("CheckInvoice");
          if (invoiceList) {
            const respObj = JSON.parse(invoiceList);
            this.setState({ invoices: respObj });
          }
        } else {
          const respObj = JSON.parse(json);
          // console.log(respObj);
          if (respObj) {
            this.setState({ invoices: respObj });
            localStorage.setItem("CheckInvoice", JSON.stringify(respObj));
            // console.log(respObj);
          }
        }
      })
      .catch(() => {
        console.log(
          "Something went wrong when checking invoice. Please try again."
        );
        const invoiceList = localStorage.getItem("CheckInvoice");
        if (invoiceList) {
          const respObj = JSON.parse(invoiceList);
          this.setState({ invoices: respObj });
        }
      });
  }

  render() {
    return (
      <div>
        <div className="account">
          <div className="account__wrapper">
            <div className="account__card">
              <div className="account__head">
                <img src={KBELogo} alt="logo" />
              </div>
              <div className="card__title">
                <center>
                  <h4 className="bold-text">Payment</h4>
                </center>
                <br />
              </div>
              <div>
                <List component="nav">
                  <Divider />
                  {
                    this.state.invoices.map(inv =>
                      <div key={inv.InvoiceSid}>
                        <Route
                          render={({ history }) => (
                            <ListItem onClick={() => {
                              if (inv.PaymentDue !== "")
                                history.push({ pathname: "/inv_payment", state: { invoice: inv } });
                              else
                                history.push({ pathname: "/receipt", state: { receiptNumber: inv.ReceiptNumber, invoiceNumber: inv.InvoiceNumber } });
                            }} button>
                              <Grid container spacing={0}>
                                <Grid item xs={10}>
                                  <ListItemText>
                                    <div className="list-text-full">
                                      {inv.PaymentDue === "" ? (
                                        <span>Invoice {inv.InvoiceNumber}</span>) : (
                                          <span className="list-text-red">Invoice {inv.InvoiceNumber}</span>
                                        )}
                                    </div>
                                    {inv.PaymentDue === "" ? (
                                      <div>
                                        <div className="list-text-full">
                                          <a>[View Receipt]</a>
                                        </div>
                                        <div className="list-text-full">
                                          Payment Date: {inv.PaymentDate}
                                        </div>
                                      </div>
                                    ) : (
                                        <div className="list-text-full">
                                          Payment Due: {inv.PaymentDue}
                                        </div>)}
                                    <div className="list-text-full">Amount: {inv.Amount}</div>
                                  </ListItemText>
                                </Grid>
                                <Grid item xs={2}>
                                  {inv.PaymentDue === "" ? (
                                    <span></span>
                                  ) : (
                                      <Button
                                        variant="outlined"
                                        type="button">
                                        Pay</Button>
                                    )}

                                </Grid>
                              </Grid>
                            </ListItem>
                          )}
                        />
                        <Divider />
                      </div>
                    )
                  }
                  <Divider />
                </List>
                <VerticalSpace />
              </div>
              <SimpleBottomNavigation value={3} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/main/Invoices.js